function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.5 10a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm0 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.25 11.98l7.2-5.38a.75.75 0 00-.9-1.2L14 11.05 8.45 6.89a.76.76 0 00-1.05.15c-.25.33-.18.8.15 1.05l5.2 3.89-5.9 4.42a.75.75 0 00.9 1.2L14 12.92l7.55 5.65c.13.1.29.15.45.15a.75.75 0 00.45-1.35l-7.2-5.39z"
})));